import * as React from "react";
import { Container, styled, Alert } from "@mui/material";

//region [[ Styles ]]
const LoginContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: theme.spacing(3),
  "& .submit-button": {
    marginTop: theme.spacing(2),
  },
}));

const ErrorMsg = styled(Alert)(({ theme }) => ({
  alignSelf: "stretch",
  marginTop: theme.spacing(2),
}));

const KahunLogo = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  width: "50%",
}));

const LoginWidgetMessageBox = styled("div")(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(2),
  display: "flex",
  flexFlow: "row",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "9px",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
  marginTop: "10px",
  fontWeight: 500,
  "& i": {
    margin: "0 4px",
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]
export interface UserLoginContainerProps {
  className?: string;
  children?: React.ReactNode;
  error?: string;
  message?: string;
  hideLogo?: boolean;
}
//endregion [[ Props ]]

export const UserLoginContainer = (props: UserLoginContainerProps) => {
  const logo = require("./assets/kahun_new_logo_black.svg");
  return (
    <LoginContainer
      maxWidth="xs"
      className={`${props.className} UserLoginContainer`}
    >
      {!props.hideLogo && (
        <KahunLogo>
          <img src={logo} alt={""} />
        </KahunLogo>
      )}
      {props.message && props.message !== "" && (
        <LoginWidgetMessageBox>
          <i className="fa fa-info-circle" aria-hidden="true" />
          {props.message}
        </LoginWidgetMessageBox>
      )}
      {props.children}
      {props.error && <ErrorMsg severity="error">{props.error}</ErrorMsg>}
    </LoginContainer>
  );
};
